import { useMemo } from 'react'

import { Avatar, FontWeight, Text } from '@hhgtech/hhg-components/mantine'
import { BoxProps, Flex, rem, Stack } from '@mantine/core'

import { getHelloSitesUrl } from 'api/utils/paths'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { assetImagePath, basePath } from 'interfaces/constants'

import useStyles from './index.styles'

type Props = {
  avatar: string
  title: string
  subTitle?: string
  titleHref?: string
  subTitleHref?: string
  role?: string
} & BoxProps
export const ExpertItem = ({
  title,
  avatar,
  subTitle,
  titleHref,
  subTitleHref,
  role,
  styles,
  classNames,
  className,
  ...rest
}: Props) => {
  const { locale } = useRouterExtend()
  const currentDomain = useMemo(() => getHelloSitesUrl(locale), [locale])
  const { cx, classes } = useStyles(undefined, {
    name: 'HomeExpert__ExpertItem',
    styles,
    classNames,
  })
  return (
    <Flex {...rest} className={cx(classes.root, className)}>
      <Avatar
        src={avatar}
        withIndicator={!!role}
        indicatorConfig={
          role
            ? {
                offset: 6,
                size: 20,
                label: (
                  <img
                    width={16}
                    height={16}
                    src={`${assetImagePath}/article-${role}.svg`}
                    alt=""
                    loading="lazy"
                  />
                ),
              }
            : undefined
        }
      />
      {(title || subTitle) && (
        <Stack
          spacing={4}
          sx={(theme) => ({
            [theme.fn.largerThan('sm')]: {
              alignItems: 'center',
            },
          })}
        >
          {title && (
            <Text
              as={titleHref ? 'a' : 'p'}
              href={titleHref}
              size="p3"
              dataEventCategory="Recommend Experts"
              dataEventAction="Experts Click"
              dataEventLabel={`${currentDomain}${basePath}/expert`}
              sx={{
                fontSize: rem(15),
                lineHeight: rem(24),
                letterSpacing: '-0.3px',
                fontWeight: FontWeight.halfBold,
                color: '#262626',
              }}
            >
              {title}
            </Text>
          )}
          {subTitle && (
            <Text
              size="c1"
              as={subTitleHref ? 'a' : 'p'}
              href={subTitleHref}
              sx={{
                fontSize: rem(12),
                lineHeight: rem(16),
                letterSpacing: '-0.2px',
                color: '#595959',
              }}
            >
              {subTitle}
            </Text>
          )}
        </Stack>
      )}
    </Flex>
  )
}
